export const CATALOGUE_LIST_PATH = "/catalogue";

const ADD_FROM_INVENTORY_PATH =
  /^\/catalogue\/([^/]+)\/add-from-inventory\/?$/;

export const catalogueAddFromInventoryPath = (catalogueId: string): string =>
  `/catalogue/${encodeURIComponent(catalogueId)}/add-from-inventory`;

export const parseCatalogueAddFromInventoryId = (
  pathname: string
): string | null => {
  const match = String(pathname || "").match(ADD_FROM_INVENTORY_PATH);
  return match ? decodeURIComponent(match[1]) : null;
};

export const isStudioCatalogueNavPath = (pathname: string): boolean =>
  pathname === CATALOGUE_LIST_PATH ||
  parseCatalogueAddFromInventoryId(pathname) !== null;

export type CatalogueFollowUpQuery = {
  catalogueId: string;
  tab: "inquiries" | "performance" | "settings";
  inquiryId?: string;
  submissionId?: string;
  linkToken?: string;
};

export const catalogueFollowUpPath = (query: {
  catalogueId: string;
  inquiryId?: string;
  submissionId?: string;
  tab?: "inquiries" | "performance";
  linkToken?: string;
}): string => {
  const params = new URLSearchParams();
  params.set("open", query.catalogueId);
  const tab =
    query.tab ||
    (query.linkToken ? "performance" : "inquiries");
  params.set("tab", tab);
  if (query.inquiryId) {
    params.set("inquiryId", query.inquiryId);
  }
  if (query.submissionId) {
    params.set("submissionId", query.submissionId);
  }
  if (query.linkToken) {
    params.set("linkToken", query.linkToken);
  }
  return `${CATALOGUE_LIST_PATH}?${params.toString()}`;
};

export const parseCatalogueFollowUpQuery = (search: string): CatalogueFollowUpQuery | null => {
  const raw = String(search || "");
  const params = new URLSearchParams(raw.startsWith("?") ? raw.slice(1) : raw);
  const catalogueId = (params.get("open") || "").trim();
  if (!catalogueId) {
    return null;
  }
  const inquiryId = (params.get("inquiryId") || "").trim() || undefined;
  const submissionId = (params.get("submissionId") || "").trim() || undefined;
  const linkToken = (params.get("linkToken") || "").trim() || undefined;
  const tabParam = (params.get("tab") || "").trim();
  const tab: CatalogueFollowUpQuery["tab"] =
    tabParam === "performance" || tabParam === "settings" ? tabParam : "inquiries";
  return {
    catalogueId,
    tab,
    inquiryId,
    submissionId,
    linkToken,
  };
};
